export const environment = {
  production: true,
  name: "PROD",
  apiURL: "/app/",
  loginUrl: "/px/",
};
